import React from 'react';
import ReactDOM from 'react-dom';
import { Trash2, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, scenario }) => {
    const { t } = useTranslation();

    if (!isOpen || !scenario) return null;

    return ReactDOM.createPortal(
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full overflow-hidden">
                {/* Header */}
                <div className="bg-gradient-to-r from-red-500 to-red-600 px-6 py-4">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                            <AlertTriangle className="h-6 w-6 text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-white">
                            {t('workshop4.operationalScenarios.deleteModal.title', 'Confirmer la suppression')}
                        </h3>
                    </div>
                </div>

                {/* Content */}
                <div className="p-6">
                    <p className="text-gray-700 mb-4">
                        {t('workshop4.operationalScenarios.deleteModal.confirmMessage', 'Êtes-vous sûr de vouloir supprimer ce scénario ?')}
                    </p>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                        <p className="font-semibold text-gray-900 mb-1">
                            {scenario.name}
                        </p>
                        <p className="text-sm text-gray-600 line-clamp-2">
                            {scenario.description}
                        </p>
                    </div>
                    <p className="text-sm text-red-600 mt-4 font-medium">
                        {t('workshop4.operationalScenarios.deleteModal.irreversibleWarning', '⚠️ Cette action est irréversible')}
                    </p>
                </div>

                {/* Actions */}
                <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-3 border-t border-gray-200">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition-colors border border-gray-300 font-medium"
                    >
                        {t('workshop4.operationalScenarios.deleteModal.cancel', 'Annuler')}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg hover:from-red-600 hover:to-red-700 transition-all shadow-sm hover:shadow-md font-medium flex items-center space-x-2"
                    >
                        <Trash2 className="h-4 w-4" />
                        <span>{t('workshop4.operationalScenarios.deleteModal.delete', 'Supprimer')}</span>
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default DeleteConfirmationModal;
